import { render, staticRenderFns } from "./ViewTerritoriesModal.vue?vue&type=template&id=04a8ddc4&scoped=true"
import script from "./ViewTerritoriesModal.vue?vue&type=script&lang=js"
export * from "./ViewTerritoriesModal.vue?vue&type=script&lang=js"
import style0 from "./ViewTerritoriesModal.vue?vue&type=style&index=0&id=04a8ddc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8ddc4",
  null
  
)

export default component.exports